export function parseHTMLContent(
  htmlString: string | null | undefined,
): string {
  const regex = /<.*?>/g;
  return htmlString?.replace(regex, '') ?? '';
}
